<template>
<div class="wrapper">
    <side-bar>
        <mobile-menu slot="content"></mobile-menu>
        <sidebar-link to="/admin/report">
            <i class="nc-icon nc-bell-55 admin-report"></i>
            <p>Report</p>
        </sidebar-link>
        <sidebar-link to="/admin/supplier">
            <i class="nc-icon nc-bell-55 admin-supplier"></i>
            <p>Supplier</p>
        </sidebar-link>
        <sidebar-link to="/admin/userlist" v-if="isAdmin">
          <i class="nc-icon nc-bell-55 report-userlist"></i>
          <p>UserList</p>
      </sidebar-link>
        <!-- <sidebar-link to="/admin/user" v-if="isDeveloper">
            <i class="nc-icon nc-bell-55"></i>
            <p>User Admin</p>
        </sidebar-link>
        <sidebar-link to="/admin/customerAccess">
          <i class="nc-icon nc-bell-55"></i>
          <p>Customer Access</p>
      </sidebar-link> -->
        <!-- <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/admin/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>User Profile</p>
      </sidebar-link>
      <sidebar-link to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/admin/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link> -->

        <template slot="bottom-links">
            <!-- <sidebar-link class="active" @click="logout">
          <i class="nc-icon nc-alien-33"></i>
          <p>Upgrade to PRO</p>
          <p>Logout</p>
        </sidebar-link> -->
            <li class="router-link-exact-active nav-item active">
                <a href="javascript:void(0)" class="nav-link" @click="logout"><i class="nc-icon nc-bell-55"></i>
                    <p>Logout</p>
                </a>
            </li>

        </template>
    </side-bar>
    <div class="main-panel">
        <top-navbar></top-navbar>

        <dashboard-content @click="toggleSidebar"></dashboard-content>

        <content-footer></content-footer>
    </div>
</div>
</template>

<style lang="scss">

</style>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
export default {
    computed: {
      isDeveloper(){
        return localStorage.getItem('username') == 'developer' ? true : false;
      },
      isAdmin(){
        return (localStorage.getItem('role') == 'developer' || localStorage.getItem('role') == 'admin') ? true : false;
      }
    },
    beforeRouteEnter(to, from, next) {
        const isLoggedIn = !!localStorage.getItem('userToken'); // Replace with your actual login check logic
        if (!isLoggedIn) {
            next('/');
        } else {
            next();
        }
    },
    components: {
        TopNavbar,
        ContentFooter,
        DashboardContent,
        MobileMenu
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        logout() {
            let self = this
            if (confirm('Are you sure you want to log out?')) {
                localStorage.removeItem('userToken');
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                self.$router.push('/');
            }
        }
    }
}
</script>
